document.querySelectorAll('.FormNearMetroList').forEach((el) => {
   new GroupCheckbox(el, '.FormNearMetroList__list', '.FormNearMetroList__title', el.querySelector('.FormNearMetroList__target span'));
   el.querySelector('.FormNearMetroList__target').addEventListener('click', (e) => {
      el.classList.toggle('FormNearMetroList--active');
   });
});


